import {
  APP_LOGIN_SET,
  APP_LOGOUT_SET,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case APP_LOGIN_SET:
      return {
        ...state,
        sessionId: action.sessionId,
      }
    case APP_LOGOUT_SET:
      return {
        ...state,
        sessionId: null,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/app.js